export default "__VITE_ASSET__CBEga1AG__"